import { create } from "zustand"

import type { Customer } from "@/lib/types"

/**
 * Client-side mirror of the logged-in customer, for synchronous reads in
 * render (chrome, "is this me?"). The source of truth stays server-side
 * (`GET /customer/auth/session`); this is hydrated/cleared by the session
 * query in `lib/auth/session.ts`.
 */
type AuthState = {
  user: Customer | null
  isAuthenticated: boolean
  setUser: (user: Customer | null) => void
  clearSession: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  setUser: (user) => set({ user, isAuthenticated: Boolean(user) }),
  clearSession: () => set({ user: null, isAuthenticated: false }),
}))
